'use client';

import { asText, Content } from '@prismicio/client';
import { Title } from '../Title';
import { useState } from 'react';
import Switcher from '../Switcher/Switcher';
import { BarChart } from '../BarChart/BarChart';
import { Button } from '@/components';
import styles from './ChartInner.module.scss';

interface Props {
  slice: Content.SwitcherChartSlice;
}

const ChartInner = ({ slice }: Props) => {
  const [activeTab, setActiveTab] = useState(1);

  return (
    <div className={styles.wrapper}>
      <Title slice={slice} activeTab={activeTab} />
      <Switcher
        switcher={slice.primary.switcher.map((item) => item.title)}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      />
      <BarChart slice={slice} activeTab={activeTab} />
      <Button
        text={slice.primary.button_text}
        link={asText(slice.primary.button_link)}
        styles={`${styles.button} ${styles.desktopButton}`}
        variation="blue"
        isArrow
      />
      <Button
        text={slice.primary.mobile_button_text}
        link={asText(slice.primary.button_link)}
        styles={`${styles.button} ${styles.mobileButton}`}
        variation="blue"
        isArrow
      />
    </div>
  );
};

export default ChartInner;
